export default __webpack_public_path__ + "static/media/assessment.4a67e86b.svg";